/**
 * Combine class names.
 *
 * @param {string} classes - Any number of class names.
 *
 * @return {string} - Combined classes.
 */
export function classNames( ...classes ) {
  return classes.filter( Boolean ).join( ' ' ) || null;
}